import crudAction from './actions'

export default {
  name: 'amenity',
  namespace: 'amenities',
  methods: [
    ...crudAction,
  ]
}
